import { panelService } from '@/services/public/panel.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { panelModel } from '@/models/api/panel.model';

export const state = {
    list: {
        data: [],
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PANEL_MODULE = "public/panel";

// ACTIONS
export const GET_ALL_PANEL = 'getAllPanel';
export const GET_PANEL = 'getPanel';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PANEL_SUCCESS = "allPanelSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PANEL_SUCCESS = "getPanelSuccess";

export const actions = {
    [GET_ALL_PANEL]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return panelService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PANEL_SUCCESS, {data: result});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PANEL]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return panelService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PANEL_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PANEL_SUCCESS](state, {data}) {
        let panel = data.data || [];
        state.list.data = panel;

        if(data.success) {
            state.list.data = panel.map(item => panelModel(item));
        }
    },
    [GET_PANEL_SUCCESS](state, data) {
        state.details = panelModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
